var listTabs = $(".tabs__product-page"),
  tabLink = listTabs.find("[data-tapTop]"),
  tabContent = listTabs.find("[data-TabContent]");

tabLink.click(function (e) {
  e.preventDefault();
  e.stopPropagation();

  var curTab = $(this),
    curTabContent = $(curTab.data("target")),
    ulElm = curTab.closest(".list-tabs");

  if (ulElm.length) {
    if (!$(this).hasClass("active")) {
      tabLink.removeClass("active");
      tabContent.removeClass("active");

      curTab.addClass("active");
      ulElm.next().find(curTab.data("target")).addClass("active");
      let dsrc = ulElm.next().find(curTab.data("target")).find("iframe[data-src]");
      if (dsrc.length > 0)
      {
        $(dsrc).attr("src",$(dsrc).attr("data-src"));
        $(dsrc).removeAttr("data-src");
      }
    }
  } else {
    console.log();
    if ($(".product-template-full-width").length) {
      if (!$(this).hasClass("active")) {
        curTab.addClass("active");

        curTabContent.show(0, function () {
          $(document.body).trigger("sticky_kit:recalc");
        });
      } else {
        curTab.removeClass("active");

        curTabContent.hide(0, function () {
          $(document.body).trigger("sticky_kit:recalc");
        });
      }
    } else if ($(".has-sticky-product-img").length) {
      if (!$(this).hasClass("active")) {
        curTab.addClass("active");
        curTabContent.show();
      } else {
        curTab.removeClass("active");
        curTabContent.hide();
      }
    } else {
      if (!$(this).hasClass("active")) {
        curTab.addClass("active");
        curTabContent.slideDown();
        let dsrc = curTabContent.find("iframe[data-src]");
        if (dsrc.length > 0)
        {
          $(dsrc).attr("src",$(dsrc).attr("data-src"));
          $(dsrc).removeAttr("data-src");
        }
      } else {
        curTab.removeClass("active");
        curTabContent.slideUp();
      }
    }
  }
});

var sprBadge = ".product-shop .spr-badge",
  btnReviewSlt =
    ".product-template-full-width .spr-summary-actions-newreview";

$(document).on("click.triggerTabsReviews", sprBadge, function () {
  if (listTabs.length) {
    $("html,body").animate(
      {
        scrollTop: listTabs.offset().top,
      },
      400
    );

    if (
      !$(".product-template-skin-1").length ||
      !$(".product-template-supermarket").length
    ) {
      var activeTab = listTabs.find('[data-target="#collapse-tab2"]');
      if (!activeTab.hasClass("active")) {
        activeTab.trigger("click");
      }
    }
  }
});
